/**
* 主页
*/ 
<template>
  <!-- 组件主盒子 -->
  <div class="stbox">

    <el-row :gutter="24">
      <el-col :span="16">
        <el-card shadow="never">
          <div slot="header" class="clearfix">
            <span>欢迎回来，{{$store.state.user.nickname}}</span>
          </div>
          <div class="card-content">
            <el-row :gutter="24">
              <el-col :span="8">
                <router-link :to="{path: '/orders'}">
                  <div class="grid-content bg-purple">
                    <div class="float-left"> <i class="el-icon-s-order"></i> 我的订单</div>
                    <div class="float-right"> 
                      <a href="javascript(0);"  style="text-decoration: none; color: #189dfe;">{{countData.order_count}}</a> 
                    </div>
                  </div>
                </router-link> 
              </el-col>
              <el-col :span="8">
                <router-link :to="{path: '/product', query:{flag: '1'}}" >
                  <div class="grid-content bg-purple">
                    <div class="float-left"> <i class="el-icon-s-order"></i> 已购服务</div>
                    <div class="float-right"> 
                      <a href="javascript(0);"  style="text-decoration: none; color: #189dfe;">{{countData.product_count}}</a>
                    </div>
                  </div>
                </router-link> 
              </el-col>
              <el-col :span="8">
                <router-link :to="{path: '/product', query:{flag: '1'}}" >
                  <div class="grid-content bg-purple">
                    <div class="float-left"> <i class="el-icon-s-order"></i> 生效中服务</div>
                    <div class="float-right"> 
                      <a href="javascript(0);"  style="text-decoration: none; color: #189dfe;">{{countData.product_efficient_count}}</a>
                    </div>
                  </div>
                </router-link> 
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8">
                <!-- <div class="grid-content bg-purple">
                  <div class="float-left"> <i class="el-icon-s-order"></i> 待办工单</div>
                  <div class="float-right"> <span>0</span> </div>
                </div> -->
              </el-col>
            </el-row>
          </div>
        </el-card>
        <!-- 到期服务 -->
        <el-card shadow="never">
          <div slot="header" class="clearfix  fs-14">
            <span>即将到期服务 <span class="fs-12" style="font-weight: 100;">显示最近一个月即将到期的服务</span> </span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="$router.push({path:'/product',query:{flag: '2'}})">查看全部</el-button>
          </div>
          <el-table :data="dataList" style="width: 100%;font-size:12px">
            <el-table-column prop="product_name" label="服务名称" width="120">
            </el-table-column>
            <el-table-column prop="count" label="数量">
            </el-table-column>
            <el-table-column prop="start_date" label="开始时间">
            </el-table-column>
            <el-table-column prop="end_date" label="到期时间">
            </el-table-column>
          </el-table>
          <el-pagination
            :page-size="pageParmas.pageSize"
            :pager-count="7"
            layout="prev, pager, next"
            :total="pageParmas.total" @size-change="pageSizeChange" :hide-on-single-page="pageParmas.pageSize >=pageParmas.total">
          </el-pagination>
        </el-card>
        <!-- 广告 -->
        <el-card shadow="never">
          <div slot="header" class="clearfix  fs-14">
            <span>更多产品试用 </span>
          </div>
          <el-row :gutter="20" class="cardheader ggbox">
            <el-col :span="8" v-for="item in productList" :key="item.id" style="padding-bottom: 30px">
                <div style="float:left;padding-right: 10px;">
                  <img :src="item.pictureUrl" class="" />
                </div>
                <div style="float:left;">
                  <div class="gg-title">{{item.name}}</div>
                  <p class="gg-txt fs-12">{{item.description}}</p>
                  <div>
                    <div v-for="b in item.button" :key="b.id" class="button1">
                      <!-- <a :href="item.url">{{b.text}}</a> -->
                      <el-button type="primary" round
                      style="transform: scale(0.8); font-size: 12px;padding:4px;" @click="advLink(item)">{{b.text}}</el-button>
                      <!-- <el-link style="font-size:12px;color: #c92310" type="primary" :href="item.url" target="_blank">{{b.text}}</el-link> -->
                    </div>
                  </div>
                </div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="8">
        <!-- 个人信息 -->
        <el-card shadow="never">
          <div class="userinfo">
            <div class="user-info-left">
              <el-avatar :size="70" :src="$store.state.user.avatar?$store.state.user.avatar:'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'"></el-avatar>
            </div>
            <div class="user-info-right">
              <p>{{$store.state.user.nickname}}，<span style="color:#788490;">您好</span></p>
              <p>上次登录时间：<span style="color:#788490;">{{$store.state.user.lastLoginTime|loginTimeFormat}}</span></p>
            </div>
          </div>

          <el-divider></el-divider>
          <div class="userotherinfo">
            <div class="userotherinfo-left">
              <div> <span class="userotherinfo-txt">{{$store.state.user.balance?$store.state.user.balance:0}}</span></div>
              <div><span>余额(元)</span></div>
            </div>
            <el-divider class="userotherinfo-center" direction="vertical"></el-divider>
            <div class="userotherinfo-right">
              <div> <span class="userotherinfo-txt">{{$store.state.user.integral?$store.state.user.integral:0}}</span></div>
              <div><span>积分</span></div>
            </div>
          </div>
        </el-card>
        <!-- 公告 -->
        <el-card shadow="never" v-show="false">
          <div slot="header" class="clearfix">
            <span class="ml-10 fs-14">最新公告</span>
            <el-button style="float: right; padding: 3px 0" type="text">更多</el-button>
          </div>
          <div>
            <el-table :data="tableData" stripe style="width: 100%" :show-header="false">
              <el-table-column prop="name" label="内容">
              </el-table-column>
              <el-table-column prop="date" label="时间">
              </el-table-column>
            </el-table>
          </div>
        </el-card>
        <!-- 小程序 -->
        <!-- <el-card shadow="never">
          <div slot="header" class="clearfix cardheader">
            <svg style="vertical-align: middle;" t="1649430667382" class="icon" viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7935" width="32" height="32">
              <path d="M511.66989 0a510.679562 510.679562 0 1 0 511.669891 511.66989 511.66989 511.66989 0 0 0-511.669891-511.66989z" fill="#E9F5FF" p-id="7936"></path>
              <path d="M723.435203 469.250806a126.266925 126.266925 0 0 1-71.963894 54.137975 68.662798 68.662798 0 0 1-20.136686 3.301096 23.932946 23.932946 0 0 1 0-47.865892 14.359768 14.359768 0 0 0 5.281754-0.990329 75.26499 75.26499 0 0 0 46.05029-33.010961 59.749839 59.749839 0 0 0 9.078014-33.010961 73.944552 73.944552 0 0 0-77.575758-68.992907 87.479046 87.479046 0 0 0-42.254029 10.893617 67.672469 67.672469 0 0 0-35.981948 58.09929v200.706641a113.72276 113.72276 0 0 1-59.749838 99.032882 132.869117 132.869117 0 0 1-66.021922 16.505481c-69.488072 0-126.597034-52.322373-126.597034-116.858801a111.907157 111.907157 0 0 1 16.50548-57.439072 125.606705 125.606705 0 0 1 71.963895-54.137975 74.439716 74.439716 0 0 1 20.136686-3.301096 23.932946 23.932946 0 0 1 20.796905 11.883946 24.098001 24.098001 0 0 1 0 24.098001 23.932946 23.932946 0 0 1-20.796905 11.883946 14.359768 14.359768 0 0 0-5.281754 0.990328 78.731141 78.731141 0 0 0-46.05029 33.010961 59.749839 59.749839 0 0 0-9.078014 33.010961 74.109607 74.109607 0 0 0 78.070922 68.992908 86.983881 86.983881 0 0 0 42.088975-10.893617 67.34236 67.34236 0 0 0 35.981947-58.099291V412.637008a114.548034 114.548034 0 0 1 59.914893-99.032882 126.10187 126.10187 0 0 1 65.196648-17.660864c69.488072 0 126.431979 52.322373 126.431979 116.858801a110.256609 110.256609 0 0 1-16.50548 57.439072z" fill="#66B7FF" p-id="7937"></path>
              <path d="M629.51902 502.921986m-21.787234 0a21.787234 21.787234 0 1 0 43.574468 0 21.787234 21.787234 0 1 0-43.574468 0Z" fill="#FFBE00" p-id="7938"></path>
              <path d="M393.985816 520.747905m-21.787234 0a21.787234 21.787234 0 1 0 43.574468 0 21.787234 21.787234 0 1 0-43.574468 0Z" fill="#FFBE00" p-id="7939"></path>
            </svg>
            <span class="ml-10">小程序</span>

          </div>
          <div>
            <div class="wxewmbox">
              <div>
                <img src="../../assets/img/zomowxewm.png" class="" />
              </div>
              <div class="ml-10">
                <h5 class="m0">华万微平台</h5>
                <p class="fs-12">华万微平台</p>
              </div>

            </div>
          </div>
        </el-card> -->
        <!-- 服务号 -->
        <el-card shadow="never">
          <div slot="header" class="clearfix cardheader">
            <svg style="vertical-align: middle;"  t="1649428624529" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6912" width="32" height="32">
              <path d="M669.3 369.4c9.8 0 19.6 0 29.4 1.6C671 245.2 536.9 152 383.2 152 211.6 152 71 269.7 71 416.8c0 85 45.8 156.9 124.2 210.9l-31.1 93.2L273.6 667c39.2 8.2 70.3 16.3 109.5 16.3 9.8 0 19.6 0 31.1-1.6-6.5-21.3-9.8-42.5-9.8-65.4 0.1-135.7 116.2-246.9 264.9-246.9z m-168.4-85c24.5 0 39.2 16.3 39.2 39.2 0 22.9-16.3 39.2-39.2 39.2-24.5 0-47.4-16.4-47.4-39.2 0-24.5 24.6-39.2 47.4-39.2z m-216.3 73.1c-24.7 0-47.8-16.2-47.8-38.8 0-24.3 24.7-38.8 47.8-38.8s39.5 16.2 39.5 38.8c0.1 22.7-16.4 38.8-39.5 38.8z" fill="#24DB5A" p-id="6913"></path>
              <path d="M953.8 613c0-125.9-124.2-227.2-264.8-227.2-148.8 0-266.5 103-266.5 227.2 0 125.9 117.7 227.2 266.5 227.2 31.1 0 62.1-8.2 93.2-16.3l85 47.4-22.9-78.5c62.1-47.4 109.5-109.5 109.5-179.8z m-351.5-39.2c-14.7 0-31.1-14.7-31.1-31.1 0-14.7 16.3-31.1 31.1-31.1 22.9 0 39.2 16.3 39.2 31.1 0 16.4-14.7 31.1-39.2 31.1z m178-7.6c-14.8 0-31.3-14.6-31.3-30.7 0-14.6 16.5-30.7 31.3-30.7 23.1 0 39.5 16.2 39.5 30.7 0 16.2-16.4 30.7-39.5 30.7z" fill="#24DB5A" p-id="6914"></path>
            </svg>
            <span class="ml-10">关注服务平台</span>

          </div>
          <div>
            <div class="wxewmbox">
              <div>
                <img src="../../assets/img/huawan.png" class="" />
              </div>
              <div class="ml-10">
                <h5 class="m0">华万</h5>
                <p class="fs-12">关注后可扫码登录</p>
              </div>

            </div>
            <!-- <div class="wxewmbox">
              <div>
                <img src="../../assets/img/zomowxewm.png" class="" />
              </div>
              <div class="ml-10">
                <h5 class="m0">中目</h5>
                <p class="fs-12">中目公众号说明</p>
              </div>

            </div> -->
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script type="text/ecmascript-6">
import {dashboardProductList, dashboardCount, sysProductList, productClue} from '../../api/basisMG'
import moment from 'moment'

export default {
  name: 'welcome',
  data() {
    return {
      pageParmas:{
        currentPage: 1,
        pageSize: 5,
        total: 0
      },
      countData: {
        order_count: 0,
        product_count: 0,
        expired_product_count: 0
      },
      tableData: [
        {
          date: '2022-05-02',
          name: '中目5.5更新啦'
        },
        {
          date: '2022-05-04',
          name: '深信服产品上线'
        }
      ],
      dataList: [],
      productList: [], //产品列表
    }
  },
  // 导入组件
  components: {
    // 点聚合组件
  },
  // 创建完毕状态(里面是操作)
  created() {},
  // 挂载结束状态(里面是操作)
  mounted() {
    dashboardCount().then(res=>{
      if(res.code==0){
        this.countData = res.data
      }
    })

    this.getDashboardProductList(this.pageParmas.currentPage, this.pageParmas.pageSize)
    sysProductList({page:1,pageSize: 20}).then(res=>{
      if(res.code==0){
        this.productList = res.data
      }
    })
  },
  // 里面的函数只有调用才会执行
  methods: {
    pageSizeChange(val){
      this.pageParmas.currentPage = val.currentPage
      this.pageParmas.pageSize = val.pageSize
      this.getDashboardProductList(this.pageParmas.currentPage, this.pageParmas.pageSize)
    },
    getDashboardProductList(page,pageSize){
      const params = {
        'page': page,
        'pageSize': pageSize 
      }
      dashboardProductList(params).then(res=>{
        if(res.code==0){
          this.dataList = res.data
          this.pageParmas.total = res.totalCount
        }
      })
    },
    advLink(obj){
      let params = {
        customersNeed: '申请试用产品：'+obj.name,
        url: window.location.host,
        productId: obj.id
      }
      productClue(params).then(res=>{
        if(res.code==0){
          this.$message.success('已提交申请，稍后客户经理会与您联系')
        }else{
          this.$message.error(res.message)
        }
      })
    },
  },
  filters:{
    loginTimeFormat(val){
      let t = ''
      if(val){
        t = moment(val).add(8,'h').format('YYYY-MM-DD HH:mm:ss')
      }
      return t
    },
  }
}
</script>
<style>
.stbox {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: #f0f2f5;
  padding: 10px;
  color: #3b3939;
}

.stbox .el-card {
  margin-bottom: 15px;
}
.stbox .clearfix {
  font-weight: 600;
}

.stbox .el-row {
  margin-bottom: 20px;
}
.stbox .el-col {
  border-radius: 2px;
}
.stbox .bg-purple-dark {
  background: #99a9bf;
}
.stbox .bg-purple {
  background-color: #f3f6fb;
}
.stbox .bg-purple-light {
  background: #e5e9f2;
}
.stbox .grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.stbox .row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.stbox .float-left {
  float: left;
  margin-left: 10px;
  margin-top: 7px;
  font-size: 14px;
  color: #333;
}
.stbox .float-right {
  float: right;
  margin-right: 10px;
  margin-top: 10px;
  font-size: 14px;
  color: #1890ff;
  font-weight: normal;
  cursor: pointer;
  float: right;
}
.stbox .userinfo {
  display: flex;
  align-items: center; /**让div里的内容垂直居中 */
}
.stbox .user-info-left {
  /* flex: 1; */
  width: 25%;
}
.stbox .user-info-right {
  /* flex: 1; */
  width: 75%;
  font-size: 14px;
}
.stbox .userotherinfo {
  display: flex;
  align-items: center;
  font-size: 12px;
}
.stbox .userotherinfo-left,
.stbox .userotherinfo-right {
  flex: 1;
  text-align: center;
  color: #788490;
}
.stbox .userotherinfo-center {
  height: 30px;
}
.stbox .userotherinfo-txt {
  font-size: 22px;
  color: #1890ff;
}
/* .stbox .cardheader {
  display: flex;
  /* align-items: center; */
  /* font-size: 14px;
  padding-right: 30px;
  flex: 1
} */ 
.stbox .ml-10 {
  margin-left: 10px;
}
.stbox .wxewmbox {
  display: flex;
  margin: 22px 20px;
  overflow: hidden;
}
.stbox .wxewmbox img {
  height: 120px;
  width: 120px
}
.stbox .fs-14 {
  font-size: 14px;
}
.stbox .fs-12 {
  font-size: 12px;
  color: #788490;
}
.stbox .m0 {
  margin: 0;
}
.stbox  img {
  height: 72px;
  width: 72px;
}
.stbox .gg-title {
  font-size: 14px;
  font-weight: 500;
}
.stbox .ggbox-2 {
  padding: 0px 20px 0px 10px;
}
.button1{
    float:left;
}
/* .ggbox .el-col {
    padding-bottom: 20px;
} */
</style>


// WEBPACK FOOTER //
// src/views/dashboard/Dashboard.vue